import React, { ReactNode, Fragment, FunctionComponent, useEffect, useState, useRef, useMemo } from 'react';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import { Cell, Row, downloadSheets, generateSheet, listToObject, SheetHeaderDisplay } from '../../../utils';
import XLSX, { Range } from 'xlsx-js-style';
import { 
  Button, 
  Row as BSRow, 
  Table,
  Dropdown,
  DropdownButton,
  FormControl,
  Col,
  InputGroup,
  Form,
  Modal,
  Container,
  Form as FormInput,
} from 'react-bootstrap';
import { 
  AuthedLayout ,
  CheckBoxField,
  TextField,
  OverflowWithTooltip,
  HeaderDisplayKeysWithType,
  InlineEditableTable,
  ErrorModal,
  EditableTableDiv,
  EditableProperties,
 } from '../../../components';
import apis from '../../../apis';
import { Fluor, NeverFluor } from '../../../apis/FluorApi';
import { ClassMapObj, Nullable } from '../../../types';
import { toast } from 'react-toastify';
import { StudentGradeNoSeat, TeeFluorLack, NeverFluorStudent, StudentFluor, Class } from '../../../model';
import { ClassSem, WrapClassBaseLayout } from '../../../layouts';

const borderStyle = { color: { rgb: '000000' }, style: 'thin' } as const;
const fullBorderStyle = {
  top: borderStyle,
  bottom: borderStyle,
  left: borderStyle,
  right: borderStyle,
} as const;
const cellAlignStyle = {
  horizontal: 'center',
  vertical: 'center',
} as const;
const monthsObj = {
    'sem1': [
      {
        id: 8,
        text: '8月',
        year: 0
      },
      {
        id: 9,
        text: '9月',
        year: 0
      },
      {
        id: 10,
        text: '10月',
        year: 0
      },
      {
        id: 11,
        text: '11月',
        year: 0
      },
      {
        id: 12,
        text: '12月',
        year: 0
      },
      {
        id: 1,
        text: '1月',
        year: 1
      },
    ],
    'sem2': [ 
      {
        id: 2,
        text: '2月',
        year: 1
      },
      {
        id: 3,
        text: '3月',
        year: 1
      },
      {
        id: 4,
        text: '4月',
        year: 1
      },
      {
        id: 5,
        text: '5月',
        year: 1
      },
      {
        id: 6,
        text: '6月',
        year: 1
      },
      {
        id: 7,
        text: '7月',
        year: 1
      },
    ]
  };
const neverfluorheader: Row[] = [
    {
      cells: [
        // {
        //   value: '',
        //   style: { border: fullBorderStyle },
        // },
        {
          value: '年級',
          style: { border: fullBorderStyle },
        },
        {
          value: '班級',
          style: { border: fullBorderStyle },
        },
        {
          value: '座號',
          style: { border: fullBorderStyle },
        },
        {
          value: '學生',
          style: { border: fullBorderStyle },
        },
      ],
    },
  ]; 
const fluorheader: Row[] = [
    {
      cells: [
        // {
        //   value: '',
        //   style: { border: fullBorderStyle },
        // },
        {
          value: '次',
          style: { border: fullBorderStyle },
        },
        {
          value: '實施日期',
          style: { border: fullBorderStyle },
        },
      ],
    },
  ];  
type classFluorCount = {
  className: string;
  classGrade?: number;
  classNo?: number;
  times: number;
};
  
type classFluorSetting = Nullable<classFluorCount> & EditableProperties;

type FluorDates = {
  id: number;
  year: number;
  sem: number;
  classGrade: number;
  classNo: number;
  dates: string[];
  schoolId: string;
};
type singleFluorDate = {
  id: number;
  year: number;
  sem: number;
  date: string;
};
type FluorHeader = Nullable<FluorDates> & EditableProperties;
const FluorDisplayHeader: HeaderDisplayKeysWithType<singleFluorDate>[] = [
  { 
    property: 'year', 
    display: '次',
    onRender: (v, i) => {
      return i + 1;
    } },
  { 
    property: 'date', 
    display: '實施日期',
    onRender: (v) => {
      return v.split("T")[0];
    }
  },
];
const classheader: HeaderDisplayKeysWithType<FluorDates>[] = [
  // { property: 'className', display: '班級' },
  { property: 'classGrade', display: '年級' },
  { property: 'classNo', display: '班級' },
  { property: 'dates', display: '實施次數', onRender: (v) => { return v.length; } },
];
const transformTextInput = (
  property: string,
  v: unknown,
  i: number,
  e?: boolean
) => (e ? <TextField property={property} /> : wrapOverflow(v as string));
const TeeFluorLackHeader: (SheetHeaderDisplay<MetricPageData> & 
  HeaderDisplayKeysWithType<MetricPageData>)[] = [
  { property: 'year', display: '學年' },
  { property: 'sem', display: '學期' },
  { property: 'pid', display: '統編' },
  { property: 'name', display: '學生' },
  { property: 'grade', display: '年級' },
  { property: 'no', display: '班級' },
  { property: 'seat', display: '座號' },
  { 
    property: 'lackCount',
    display: '未實施次數',
    onRender: transformTextInput.bind(null, 'lackCount'),
  }
];
const TeeFluorNerverParticipateHeader: (SheetHeaderDisplay<NeverFluorStudent> & 
  HeaderDisplayKeysWithType<NeverFluorStudent>)[] = [
  { property: 'grade', display: '年級' },
  { property: 'no', display: '班級' },
  { property: 'seat', display: '座號' },
  { property: 'name', display: '學生' },
];
const TeeFluorHeader: (SheetHeaderDisplay<StudentFluor> & 
  HeaderDisplayKeysWithType<StudentFluor>)[] = [
  { property: 'grade', display: '年級' },
  { property: 'no', display: '班級' },
  { property: 'seat', display: '座號' },
  { property: 'name', display: '學生' },
];
function wrapOverflow(content: ReactNode) {
  return <OverflowWithTooltip>{content}</OverflowWithTooltip>;
}
const mapState = (state: ApplicationState, ownProps: ClassSem) => ({
  ...ownProps,
  ...state.auth,
});
const mapDispatches = ErrorDispatches;

const connector = connect(mapState, mapDispatches);

type Props = ConnectedProps<typeof connector>;
type MetricPageData = StudentGradeNoSeat & TeeFluorLack;

const fluorSetting: FunctionComponent<Props> = ({
    year,
    sem,
    user,
    catchErrorForModal,
  }) => {
    const [month, setMonth] = useState<number>();
    const [rocYear, setROCYear] = useState<number>();
    const [monthText, setMonthText] = useState();
    const [dates, setDates] = useState <string[]>([]);
    const [date, setDate] = useState<number>();
    const [count, setCount] = useState<number>();
    const currentSem = user.semesters[user.currentSemester];
    const semMonths = sem == 1 ? monthsObj['sem1'] : monthsObj['sem2'];
    const selectedMonth = semMonths.find(m => m.id === month);
    const displayMonthText = selectedMonth
      ? year + (selectedMonth.year) + '年' + selectedMonth.text
      : '實施月';

    const [fluordatas, setFluorDatas] = useState<Fluor>([]);
    const [fluordatastable, setFluorDataTable] = useState<singleFluorDate[]>([]);
    const [classes, setClasses] = useState<ClassMapObj>({ '': '無年級資料' });
    const [classList, setClassList] = useState([] as Class[]);
    const [isClick, setIsClick] = useState<boolean>();
    const [isClickNever, setIsClickNever] = useState<boolean>();
    const [isClickSFluor, setIsClickSFluor] = useState<boolean>();
    const [neverfluordatas, setNeverfluorDatas] = useState([] as NeverFluorStudent[]);
    const [studentfluordatas, setStudentfluorDatas] = useState([] as StudentFluor[]);
    const [studentsFluorLack, setStudentFluorLack] = useState([] as MetricPageData[]);  
    const studentInputRef = useRef<HTMLInputElement>(null);
    const teeLackInputRef = useRef<HTMLInputElement>(null);
    const [insertBtn, setInsertBtn] = useState<boolean>(true);
    const [noParticipantBtn, setNoParticipantBtn] = useState<boolean>(true);
    const [sid, setSid] = useState<string>('');
    const [pid, setPid] = useState<string>('');
    const [grade, setGrade] = useState<number>();
    const [no, setNo] = useState<number>();
    const [seat, setSeat] = useState<number>();
    const [checkField, setCheckField] = useState<number>(0);
    const ref = useRef<HTMLInputElement>(null);
    const [neverFluorDeleting, setNeverFluorDeleting] = useState(false);
    const [deletingNeverFluorStudent, setDeletingNeverFluorStudent] = useState<NeverFluorStudent>();
    const [studentFluorDeleting, setStudentFluorDeleting] = useState(false);
    const [insertLastSemStudent, setInsertLastSemStudent] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [fluorTimes, setFluorTimes] = useState<number>();
    const [editingSetting, setEditingSetting] = useState<FluorDates>({} as FluorDates);
    const timesInputRef = useRef<HTMLInputElement>(null);
    const [deletingStudentFluor, setDeletingStudentFluor] = useState<StudentFluor>();
    const [fluorSettings, setFluorSettings] = useState<classFluorCount[]>([]);
    const [selectedIndex, setSelectedIndex] = useState<Set<number>>(
      new Set<number>()
    );
    const [pageName, setPageName] = useState('settings');
    const fluorSettingData = useMemo(refreshSettings, [
      selectedIndex, fluorSettings
    ]);

    useEffect(() => {
      const newSemMonths = sem == 1 ? monthsObj['sem1'] : monthsObj['sem2'];

      if (newSemMonths.length > 0) {
        setMonth(newSemMonths[0].id);
        setROCYear(year + newSemMonths[0].year);
        setDate(1);
      }

      apis
        .getClasses(year, sem)
        .then((classes) => {
         if (classes.length) {
            setClassList(classes);
            setClasses(
              listToObject(
                classes,
                (c) => c.id,
                (c) => c.name
              )
            );
          }
      })
      .catch(catchErrorForModal);
    }, [year, sem]);

    useEffect(() => {
      if(month) {
        const currentYear = new Date().getFullYear();
        const daysInMonth = new Date(currentYear, month, 0).getDate();
        setDates(Array.from({length: daysInMonth}, (v, i) => i + 1 + '日'));
      }
    }, [month]);

    useEffect(() => {
      apis.getFluorList(year, sem).then((s) => {
        const validClassKeys = new Set(
          Array.isArray(classList) ? classList.map(c => `${c.grade}-${c.no}`) : []
        );

        // 過濾漱口水清單（排除已被刪除的班級）
        const filteredSettings = s.filter(item => 
          validClassKeys.has(`${item.classGrade}-${item.classNo}`)
        );

        if(filteredSettings.length) {
          const defaultSetting = filteredSettings.reduce((maxItem, currentItem) => {
            const maxLength = maxItem.dates?.length ?? 0;
            const currentLength = currentItem.dates?.length ?? 0;

            return currentLength > maxLength ? currentItem : maxItem;
          });

          const result = defaultSetting
            ? defaultSetting.dates.map(d => ({
                schoolId: defaultSetting.schoolId,
                date: d,
                sem: defaultSetting.sem,
                year: defaultSetting.year,
                id: defaultSetting.id
              }))
            : [];
          setFluorDatas(filteredSettings.map(item => ({
            ...item,
            selected: false
          })));
          setFluorDataTable(result);
        }
      });
    }, [isClick, month]);

    useEffect(() => {
      apis.getFluorList(year, sem).then(async (s) => {
        // 若api回傳的資料沒有年級班級，則新增所有年級與班級的資料，並套用同一個漱口水日期清單
        const hasClassGrade = s.some(item => item.classGrade !== 0);

        if(hasClassGrade) {
          const result = s.flatMap(item =>
            item.dates.map(date => ({
              schoolId: item.schoolId,
              date: date,
              sem: item.sem,
              year: item.year,
              id: item.id
            }))
          );
          const fluorList = s.map((item, index) => {
            if(item.classGrade === 0 && item.classNo === 0) {
              return {
                selected: false,
                schoolId: item.schoolId,
                date: item.dates[0],
                sem: item.sem,
                year: item.year,
                id: item.id
              }
            }
          });
          const validClassKeys = new Set(
            Array.isArray(classList) ? classList.map(c => `${c.grade}-${c.no}`) : []
          );

          // 過濾漱口水清單（排除已被刪除的班級）
          const filteredSettings = s.filter(item => 
            validClassKeys.has(`${item.classGrade}-${item.classNo}`)
          );

          setFluorDatas(filteredSettings.map(item => ({
              ...item,
              selected: false
          })));
          // console.log('setFluorDataTable',result) //TODO
          // setFluorDataTable(result);
        } else {
          // 新增所有年級與班級的資料，並套用同一個漱口水日期清單
          const fluorDates = s.find(item => item.classGrade === 0)?.dates || [];
          const insertData = classList.map (c => ({
            id: 0,
            year: year,
            sem: sem,
            classGrade: c.grade,
            classNo: c.no,
            dates: fluorDates,
            schoolId: user.schools[user.currentSchool].id,
          }));
          await apis.createFluor(insertData);
        }
      });
    }, [classList]); 

    useEffect(() => {
      if (classList.length) {
        const tableData = classList.map(x => ({
          className: x.name,
          date: fluordatas.length ? fluordatas[0].dates : [],
          times: fluordatas.length ? fluordatas[0].dates.length : 0,
        }));
        setFluorSettings(tableData);
      }
    }, [classList, fluordatas, year, sem]);
    useEffect(() => {
      apis.getNeverFluorList(
        year,
        sem
      ).then((s) => {
          setNeverfluorDatas(s);
        });
    }, [isClickNever, year, sem]); 
    useEffect(() => {
      apis.getStudentFluorList(
        year,
        sem
      ).then((s) => {
          const result = s.filter(t => t.lackCount === 0); // 本學期不參加者清單 不顯示含氟漱口水未實施者
          setStudentfluorDatas(result);
        });

      getStudentFluorLack();
    }, [isClickSFluor, year, sem]); 
    
    function refreshSettings() {
      return fluorSettings.map((s, i) => ({
        ...s,
        selected: selectedIndex.has(i),
      }));
    }

    function getInsertData(month: number, date: number, count: number) {
      const upsertData = classList.map(c => ({
        id: 0,
        year: year,
        sem: sem,
        classGrade: c.grade,
        classNo: c.no,
        dates: getFluorDates((rocYear || year + (month < 8 ? 1 : 0)) + 1911, month, date, count),
        schoolId: user.schools[user.currentSchool].id,
      }));

      toast
        .promise(
        apis.upsertFluorDateList(upsertData),
      {
        pending: '資料新增中......',
        success: '新增成功！',
        error: '新增失敗！請查看錯誤資訊。',
      }
        )
        .then(() => {
          setIsClick(!isClick);
        })
        .catch();
    }

    function getFluorDates(
      year: number,
      month: number,
      date: number,
      count: number
    ): string[] {
      const startDate = new Date(year, month - 1, date);

      return Array.from({ length: count }, (_, index) => {
        const d = new Date(startDate);
        d.setDate(startDate.getDate() + index * 7);
        return d.toISOString();
      });
    }

    function CheckNoParticipantBtn() {
      setNoParticipantBtn(true);
      if(ref.current?.value) {
        setNoParticipantBtn(false);
        CheckInput(ref.current?.value);
      }
    }

    function CheckInsertBtn() {
      setInsertBtn(true);
      if (teeLackInputRef.current?.value) {
        if(studentInputRef.current?.value) {
            setInsertBtn(false); 
            CheckInput(studentInputRef.current?.value);
        }
      }
    }

    function CheckInput(inputStudent: string) {
      // 檢查輸入身分證、學號或班級座號
      if(inputStudent) {
        if(inputStudent.substring(0, 1) == '=') {
          setSid(inputStudent.substring(1));
          setCheckField(2);
        } else {
          switch(inputStudent.length) {
            case 5:
              setGrade(parseInt(inputStudent.substring(0, 1)));
              setNo(parseInt(inputStudent.substring(1, 3)));
              setSeat(parseInt(inputStudent.substring(3, 5)));
              setCheckField(3);
              break;
            case 6:
              // 代入年級、班級、座號
              setGrade(parseInt(inputStudent.substring(0, 2)));
              setNo(parseInt(inputStudent.substring(2, 4)));
              setSeat(parseInt(inputStudent.substring(2, 4)));
              setCheckField(3);
              break;
            case 10:
            case 11:
            case 12:
              setPid(inputStudent);
              setCheckField(1);
              break;
          }
        }
      }
    }
    
    function insertTeeLack() {
      if(studentInputRef.current?.value) {
        toast
        .promise(
          apis.createStudentFlourLack(
              year,
              sem,
              sid,
              seat || 0,
              no || 0,
              grade || 0,
              pid,
              false, 
              teeLackInputRef.current?.value ? parseInt(teeLackInputRef.current?.value) : 0,
              checkField
          ),
          {
            pending: '資料新增中......',
            success: '新增成功！',
          }
        )
        .then((r) => {
          // 清空學號、未實施次數
          if(studentInputRef.current) {  
            studentInputRef.current.value = '';
          }
          if(teeLackInputRef.current) {  
            teeLackInputRef.current.value = '';
          }
          CheckInsertBtn(); // 按鈕disabled
          getStudentFluorLack();
        })
        .catch(catchErrorForModal);
      }
    }
    
    function onValueUpdate(value: TeeFluorLack) {
      apis
        .updateStudentFluorLack(
          value?.id,
          value?.participate,
          value?.lackCount,
          value?.fluorId,
          value?.studentId,
        )
        .then(getStudentFluorLack)
        .catch(catchErrorForModal);
    }

    function onValueDelete(value: TeeFluorLack) {
      apis
        .deleteStudentFluorLack(
          value?.id,
          value?.participate,
          value?.lackCount,
          value?.fluorId,
          value?.studentId,
        )
        .then(getStudentFluorLack)
        .catch(catchErrorForModal);
    }

    function onValueDeleteNeverFlour(value: NeverFluorStudent) {
      setNeverFluorDeleting(true);
      setDeletingNeverFluorStudent(value);
    }

    function deleteNeverFluorStudent() {
      if(deletingNeverFluorStudent) {
        toast
        .promise(
          apis
            .deleteNeverFluor(
              deletingNeverFluorStudent?.id,
              deletingNeverFluorStudent?.studentId,
              deletingNeverFluorStudent?.schoolId,
            ),
            {
              pending: '資料刪除中......',
              success: '刪除成功！',
              error: '刪除失敗！請查看錯誤資訊。',
            }
          )
          .then(() => {
            onHideDeletingNeverFluorStudent();
            setIsClickNever(!isClickNever);
          })
          .catch(catchErrorForModal);
      }
    }

    function onHideDeletingNeverFluorStudent() {
      setNeverFluorDeleting(false);
      setDeletingNeverFluorStudent(undefined);
    }
    
    function onValueDeletStudentFlour(value: StudentFluor) {
      setStudentFluorDeleting(true);
      setDeletingStudentFluor(value);
    }

    function deleteStudentFlour() {
      if(deletingStudentFluor) {
        toast
        .promise(
          apis
          .deleteStudentFluorLack(
            deletingStudentFluor?.id,
            deletingStudentFluor?.participate,
            deletingStudentFluor?.lackCount,
            deletingStudentFluor?.fluorId,
            deletingStudentFluor?.studentId,
          ),
          {
            pending: '資料刪除中......',
            success: '刪除成功！',
            error: '刪除失敗！請查看錯誤資訊。',
          }
        )
        .then(() => {
          setIsClickSFluor(!isClickSFluor);
          onHideDeletingStudentFlour();
        })
        .catch(catchErrorForModal);
      }
    }

    function onHideDeletingStudentFlour() {
      setStudentFluorDeleting(false);
      setDeletingStudentFluor(undefined);
    }

    function getStudentFluorLack() {
      apis.getStudentFluorLackList(year, sem)
      .then((s) => {
        const result = s.filter(t => t.studentFluor.lackCount !== 0); // 含氟漱口水未實施清單 不顯示本學期不參加者
        setStudentFluorLack(result.map(({ studentFluor, ...m }) => ({
          ...studentFluor,
          ...m
        })));
      })
      .catch(catchErrorForModal);
    }

    function onDeleteMetric(metric: singleFluorDate) {
      // 刪除某一日期後，所有班級會套用此清單的漱口水日期
      const newDates = fluordatastable.filter(d => d.date !== metric.date).map(d => d.date);
      const updateData = fluordatas.map(item => ({
        ...item,
        dates: newDates
      }));
      // console.log('updateData', updateData);
      toast
        .promise(
          apis.updateFluorDateList(updateData),
      {
        pending: '資料刪除中......',
        success: '刪除成功！',
        error: '刪除失敗！請查看錯誤資訊。',
      }
        )
        .then(() => {
          setIsClick(!isClick);
        })
        .catch();
    }

    // 加入上學期不參加者名單
    function insertLastSemNoParticipantStudent() {
      apis
        .insertLastSemesterStudent(year, sem)
        .then(() => {
          setIsClickSFluor(!isClickSFluor);
          setInsertLastSemStudent(false);
        })
        .catch(catchErrorForModal);
    }

    function updateClassFluorSetting(value: FluorDates) {
      setEditingSetting(value);
      setShowEditModal(true);
      setFluorTimes(value.dates.length);
    }

    function editFluorTimesByClassNo() {
      const dates = Array.isArray(editingSetting.dates)
        ? editingSetting.dates
        : [];

      const times = Number(fluorTimes) || 0;

      let newDates: string[] = [];

      if (times <= 0) {
        newDates = [];
      } else if (times <= dates.length) {
        newDates = dates.slice(0, times);
      } else {
        const addCount = times - dates.length;

        if (dates.length === 0) {
          // 原本完全沒有日期時，將今天當作第一次日期
          const firstDate = new Date(1911 + rocYear!, month! - 1, date!);

          newDates = Array.from({ length: times }, (_, index) => {
            const newDate = new Date(firstDate);
            newDate.setDate(newDate.getDate() + 7 * index);
            return newDate.toISOString();
          });
        } else {
          // 原本有日期時，從最後一次日期開始，每次往後加 7 天
          const lastDate = new Date(dates[dates.length - 1]);

          if (Number.isNaN(lastDate.getTime())) {
            toast.error('最後一筆日期格式錯誤');
            return;
          }

          const additionalDates = Array.from(
            { length: addCount },
            (_, index) => {
              const newDate = new Date(lastDate);
              newDate.setDate(newDate.getDate() + 7 * (index + 1));
              return newDate.toISOString();
            }
          );

          newDates = [...dates, ...additionalDates];
        }
      }

      const updateDate = [
        {
          ...editingSetting,
          dates: newDates,
        },
      ];

      toast
        .promise(apis.updateFluorDateList(updateDate), {
          pending: '資料更新中......',
          success: '更新成功！',
          error: '更新失敗！請查看錯誤資訊。',
        })
        .then(() => {
          setIsClick((prev) => !prev);
          setShowEditModal(false);
        })
        .catch((error) => {
          console.error('更新 Fluor 日期失敗：', error);
        });
    }
    
    function generateFluorSheet() {
      const classObj = [...selectedIndex].map(index => classList[index]);
      toast
        .promise(
          apis.downloadExcel(
            user.schools[user.currentSchool].name,
            fluordatas.length ? fluordatas[0].dates : [],
            classObj,
            year, 
            sem
          ), {
          pending: '下載中...',
          success: '下載成功！',
          error: '下載失敗！請查看錯誤資訊。',
        })
        .then((blob) => {
          const objlink = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = objlink;
          a.setAttribute('download', `含氟漱口水記錄表.xls`);
          document.body.appendChild(a);
          a.click();

          a.parentNode?.removeChild(a);
        })
        .catch(catchErrorForModal);
    }
    
    return (
      <React.Fragment>
        <ul className="nav nav-tabs">
          <li>
            <summary
              className={`text-dark font-weight-bold wid-100 nav-link ${
                pageName == 'settings' ? 'active' : ''
              }`}
              onClick={() => setPageName('settings')}
            >
              實施設定
            </summary>
          </li>
          <li>
            <summary
              className={`text-dark font-weight-bold wid-100 nav-link ${
                pageName == 'noParticipant' ? 'active' : ''
              }`}
              onClick={() => setPageName('noParticipant')}
            >
              不參加
            </summary>
          </li>
          <li>
            <summary
              className={`text-dark font-weight-bold wid-100 nav-link ${
                pageName == 'lack' ? 'active' : ''
              }`}
              onClick={() => setPageName('lack')}
            >
              未實施
            </summary>
          </li>
        </ul>
        <div className="border-right border-left border-bottom p-1 py-2">
          {pageName == 'settings' ? (
            <>
              <BSRow noGutters className="align-items-center mt-3 mb-4">
                <Col sm={6} className='d-flex align-items-center'>
                    第一次實施日期：
                    <DropdownButton
                      className="mr-2"
                      title={displayMonthText || '實施月'}
                      onSelect={(g) => {
                        if(g) {
                          const selectMonth = semMonths[parseInt(g)];
                          setMonth(selectMonth.id);
                          setROCYear(year + selectMonth.year);
                        }
                      }}
                    >
                    {semMonths.map((month, idx) => (
                      <Dropdown.Item key={`month-${idx}`} eventKey={idx}>
                        {year + (month.year)}年{month.text}
                      </Dropdown.Item>
                      ))}
                    </DropdownButton>
                    <DropdownButton
                      className=""
                      title={date ? dates[date - 1] : '實施日' }
                      onSelect={(d) => {
                      if(d) {
                          setDate(parseInt(d));
                      }
                      }}
                    >
                      {dates.map((d, idx) => (
                          <Dropdown.Item key={`date-${idx + 1}`} eventKey={idx + 1}>
                          {d}
                          </Dropdown.Item>
                      ))}
                    </DropdownButton>
                </Col>
                <Col sm={6} className='d-flex align-items-center'>
                  實施次數：
                  <DropdownButton
                      className="mr-2"
                      title={count ? count : '1'}
                      onSelect={(g) => {
                      if(g) {
                          setCount(parseInt(g));
                      }
                      }}
                  >
                      {Array.from({length: 23}, (v, i) => i+1).map((d, idx) => (
                              <Dropdown.Item key={`date-${idx + 1}`} eventKey={idx + 1}>
                              {d}
                              </Dropdown.Item>
                      ))}
                  </DropdownButton>
                  <Button
                    disabled={!date}
                    onClick={() => getInsertData(month || 1, date || 1, count || 1)}
                  >
                    設定日期及週數
                  </Button>
                </Col>
                <Col>
                  <Button
                    className='mt-2'
                    disabled={!selectedIndex.size}
                    onClick={generateFluorSheet}
                  >
                    產生記錄表
                  </Button>
                </Col>
              </BSRow>
              <BSRow noGutters className='align-items-start'>
                <Col sm={6}>
                  <EditableTableDiv
                    fixCol={1}
                    headers={classheader}
                    values={fluordatas}
                    onSelected={(s) => {
                      setSelectedIndex((last) => {
                        const next = new Set(last);

                        if (s.index !== undefined) {
                          if (s.checked) next.add(s.index);
                          else next.delete(s.index);
                        } else {
                          if (s.checked) {
                            return new Set(fluordatas.map((_, index) => index));
                          } else {
                            return new Set();
                          }
                        }

                        return next;
                      });

                      setFluorDatas(prev => {
                        if (s.index !== undefined) {
                          return prev.map((item, index) =>
                            index === s.index
                              ? { ...item, selected: s.checked }
                              : item
                          );
                        }

                        return prev.map(item => ({
                          ...item,
                          selected: s.checked
                        }));
                      });
                    }}
                    editable
                    onEdit={(v) => updateClassFluorSetting(v)}
                  />
                </Col>
                <Col sm={5} className='ml-2'>
                  <EditableTableDiv
                    deleteable
                    headers={FluorDisplayHeader}
                    values={fluordatastable}
                    onDelete={onDeleteMetric}
                  />
                </Col>
              </BSRow>
            </>
          ) : (
            pageName == 'noParticipant' ? (
              <>
                <BSRow noGutters className="mt-3 mb-4">
                   <div>
                    <span>請輸入年級班級座號或身分證或學號(學號前請加=)：</span><br />
                    <span className="text-primary">例如:國小三年級1班3號，應寫作「30103」</span>
                  </div>
                  <Col xs={2} className="mr-2">
                    <FormControl 
                      type="string"
                      aria-label="studentInput"
                      aria-describedby="basic-addon1"
                      ref={ref}
                      onChange={CheckNoParticipantBtn}
                    />
                  </Col>
                  <Col className="ml-2">
                    <Button
                      disabled={noParticipantBtn}
                      onClick={() => {
                          apis.createNeverFluor(
                            year,
                            sem,
                            sid,
                            seat || 0,
                            no || 0,
                            grade || 0,
                            pid,
                            false, 
                            0,
                            checkField
                          )
                            .then((x) =>  {
                              getStudentFluorLack();
                              setIsClickNever(!isClickNever);
                              if(ref.current) {
                                ref.current.value = "";
                              }
                            })
                            .catch(catchErrorForModal);
                      }}
                    >
                      新增永不參加名單
                    </Button>
                    <Button className="ml-2"
                      disabled={noParticipantBtn}
                      onClick={() => {
                        apis.createStudentFlourLack(
                          year,
                          sem,
                          sid,
                          seat || 0,
                          no || 0,
                          grade || 0,
                          pid,
                          false,
                          0,
                          checkField
                        ).then(
                        (x) =>  {    
                          setIsClickSFluor(!isClickSFluor);
                        }).catch(catchErrorForModal);
                      }}
                    >
                      新增本學期不參加名單
                    </Button>
                    <Button
                      className="ml-2"
                      onClick={() => {setInsertLastSemStudent(true)}}  
                    >
                      加入上學期不參加者名單
                    </Button>
                  </Col>
                </BSRow>
                <BSRow noGutters className='align-items-start'>
                  <Col xs={5}>
                    永不同意參加者
                    <EditableTableDiv
                      deleteable
                      headers={TeeFluorNerverParticipateHeader}
                      values={neverfluordatas}
                      onDelete={onValueDeleteNeverFlour}
                    />
                  </Col>
                  <Col xs={5} className='ml-2'>
                    本學期不參加者
                    <EditableTableDiv
                      deleteable
                      headers={TeeFluorHeader}
                      values={studentfluordatas}
                      onDelete={onValueDeletStudentFlour}
                    />
                  </Col>
                </BSRow>
              </>
            ) :
            (
              <>
                <BSRow noGutters className='mt-3'>
                  <div>
                    <span>請輸入年級班級座號或身分證或學號(學號前請加=)：</span><br />
                    <span className="text-primary">例如:國小三年級1班3號，應寫作「30103」</span>
                  </div>
                  <Col xs={2} className="mr-2">
                    <FormControl 
                      type="string"
                      aria-label="studentInput"
                      aria-describedby="basic-addon1"
                      ref={studentInputRef}
                      onChange={CheckInsertBtn}
                    />
                  </Col>
                  未實施次數：
                  <Col xs={2} className="mr-2">
                    <FormControl 
                    type="number"
                    aria-label="teeUnCheckInput"
                    aria-describedby="basic-addon1"
                    ref={teeLackInputRef}
                    onChange={CheckInsertBtn}
                    />
                  </Col>
                  <Col xs={1}>
                    <Button
                      disabled={insertBtn}
                      onClick={insertTeeLack}
                    >
                      新增
                    </Button>
                  </Col>
                  <Col xs={12} className='mt-4'>
                    含氟漱口水未實施
                    <InlineEditableTable
                      values={studentsFluorLack}
                      headers={TeeFluorLackHeader}
                      onValueUpdate={onValueUpdate}
                      onValueDelete={onValueDelete}
                      onRowRender={(v) => ({
                        editable: true,
                        deleteable: true,
                      })}
                    />
                  </Col>
                </BSRow>
              </>
            )
          )}
        </div>
        <Modal
          show={neverFluorDeleting}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          centered
          >
          <Modal.Header closeButton onHide={onHideDeletingNeverFluorStudent}>
              <Modal.Title id="contained-modal-title-vcenter">刪除</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <Container>
                  <BSRow className='mb-3'>
                      <Col>您確定要刪除嗎?</Col>
                  </BSRow>
              </Container>
          </Modal.Body>
          <Modal.Footer>
              <Button type="submit" variant="danger" onClick={deleteNeverFluorStudent}>
              確認
              </Button>
              <Button type="reset" variant="secondary" onClick={onHideDeletingNeverFluorStudent}>
              取消
              </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={studentFluorDeleting}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          centered
          >
          <Modal.Header closeButton onHide={onHideDeletingStudentFlour}>
              <Modal.Title id="contained-modal-title-vcenter">刪除</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <Container>
                  <BSRow className='mb-3'>
                      <Col>您確定要刪除嗎?</Col>
                  </BSRow>
              </Container>
          </Modal.Body>
          <Modal.Footer>
              <Button type="submit" variant="danger" onClick={deleteStudentFlour}>
              確認
              </Button>
              <Button type="reset" variant="secondary" onClick={onHideDeletingStudentFlour}>
              取消
              </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showEditModal}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          centered
          >
          <Modal.Header closeButton onHide={() => setShowEditModal(false)}>
              <Modal.Title id="contained-modal-title-vcenter">編輯漱口水次數</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <Container>
                <BSRow>
                  <Col sm={1}>年級:</Col>
                  <Col sm={3}>
                    {editingSetting.classGrade}年{editingSetting.classNo}班
                  </Col>
                  <Col sm={1}>次數:</Col>
                  <Col sm={3}>
                    <FormInput.Control
                      className="mr-2"
                      value={fluorTimes}
                      placeholder="次數"
                      aria-label="pid"
                      aria-describedby="basic-addon1"
                      ref={timesInputRef}
                      onChange={(e) => {
                        setFluorTimes(parseInt(e.target.value) || 0);
                      }}
                    />
                  </Col>
                </BSRow>
              </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="danger" onClick={editFluorTimesByClassNo}>
              確認
            </Button>
            <Button type="reset" variant="secondary" onClick={() => setShowEditModal(false)}>
              取消
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={insertLastSemStudent}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          centered
          >
          <Modal.Header closeButton onHide={() => {setInsertLastSemStudent(false)}}>匯入上學期不參加者名單</Modal.Header>
          <Modal.Body>
              <Container>
                  <BSRow className='mb-3'>
                      <Col>確認是否匯入上學期不參加者名單?</Col>
                  </BSRow>
              </Container>
          </Modal.Body>
          <Modal.Footer>
              <Button type="submit" onClick={insertLastSemNoParticipantStudent}>
              確認
              </Button>
              <Button type="reset" variant="secondary" onClick={() => {setInsertLastSemStudent(false)}}>
              取消
              </Button>
          </Modal.Footer>
        </Modal>
        
      </React.Fragment>
    );
  };


   
  export const FluorSetting = connector(WrapClassBaseLayout(fluorSetting));
